import { Injectable } from '@angular/core';
import { ArticleCard, FacilityCard, VoiceCard, Sitemap, ReleaseInfo } from './iris.interface';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument, DocumentSnapshot } from '@angular/fire/firestore';
import { Observable, Subscription } from 'rxjs';
import { listLazyRoutes } from '@angular/compiler/src/aot/lazy_routes';
import { I } from '@angular/cdk/keycodes';
import { Iris } from './iris.enum';

@Injectable({
  providedIn: 'root'
})
export class IrisService {
  private irisCollection: AngularFirestoreCollection;
  private irisDoc: AngularFirestoreDocument<Sitemap>;
  public isInit: Boolean = false;
  subsc: Subscription;
  sitemap: Sitemap;
  filteredArticles: ArticleCard[];
  voiceCard: VoiceCard;
  facilityCard: FacilityCard;
  static pindex: number = 0;
  static activeRoute: boolean = false;
  static stackedArticles: ArticleCard[];

  constructor(
    private readonly db: AngularFirestore
  ) {
    console.log('iris service constructor');
    this.irisCollection = this.db.collection('iris');
    this.irisDoc = this.irisCollection.doc<Sitemap>('sitemap');
  }
  
  /**
   * サービス初期化
   */
  public init() {
    console.log('iris service init');
    return new Promise<string>((resolve, rejected) => {
      this.irisDoc.get().subscribe(x => {
        if (x.exists) {
          console.log('iris sitemap subscribe');
          this.sitemap = Object.assign({},(x.data()));
          this.isInit = true;
          resolve('got sitemap');
        } else {
          rejected('sitemap not found');
        }
      });
    });
  }

  /**
   * サービス終了処理
   */
  public finalize() {
    console.log('iris service finalize');
    // this.subsc.unsubscribe();
  }

  /** 
   * サイトマップを登録
   */
  public addSitemap(sm: Sitemap) {
    console.log(sm);
    return this.db
      .collection('iris').doc('sitemap')
      .set(sm.deserialize());
  }

  /** 
   * 声の記事を取得
   */
  public getVoiceArticle(key: string) {
    return new Promise<VoiceCard>((resolve) => {
      this.db
      .collection<VoiceCard>('articles')
      .doc<VoiceCard>(key)
      .get()
      .subscribe(voice => {
        resolve(voice.data());
      })
    });
  }

  /** 
   * 声のすべての記事を取得
   */
  public getVoices() {
    return this.db
      .collection('articles', ref => { return ref.where('type', '==', 'search.type_voice');})
      .valueChanges();
  }

  /** 
   * 声の記事を登録
   */
  public addVoice(key: string, voice: VoiceCard) {
    // 追加日を付与
    voice.addDate = new Date();
    console.log(voice);
    return this.db
      .collection('articles').doc(key)
      .set(voice.deserialize());
  }

  /** 
   * 相談先の記事取得
   */
  public getFacilityArticle(key: string) {
    return this.db
      .collection('articles')
      .doc<FacilityCard>(key)
      .get();
  }

  /** 
   * 相談先のすべての記事を取得
   */
  public getFacilities() {
    return this.db
      .collection('facilities', ref => { return ref.where('type', '==', 'search.type_info');})
      .valueChanges();
  }

  /** 
   * 相談先の記事を登録
   */
  public addFacility(key: string, facility: FacilityCard) {
    // 追加日を付与
    facility.addDate = new Date();
    console.log(facility);
    return this.db
      .collection('articles').doc(key)
      .set(facility.deserialize());
  }

  /**
   * フィルター後の記事一覧を取得
   */
  public getFilteredArticles(argType: string, args: string[]) {
    this.filteredArticles = [];

    return new Promise<ArticleCard[]>((resolve) => {
      // 記事を並列に検索
      this.sitemap.articles.forEach(article => {
        var found: Boolean = false;
        
        // 検索タイプと記事のタイプが一致しない場合は対象から外す
        if (argType === 'search.type_info' &&
            article.type !== 'search.type_info') {
              return;
        }
        if (argType === 'search.type_voice' &&
            article.type !== 'search.type_voice') {
              return;
        }

        // タグ以外のキーワードがないかチェック
        var hasKeyword: Boolean = false;
        var keyword: string = '';
        for (const arg of args) {
          if (arg.includes('tag')) {
            // タグ
          } else {
            hasKeyword = true;
            keyword = arg;
          }
        }

        // キーワードがあればここでフィルタリング
        if (hasKeyword) {
          // 相談先なら場所でフィルタリング
          if (argType === 'search.type_info') {
            console.log(keyword)
            if (keyword === '全国') {
              // すべてOK
            }
            if (keyword !== '全国') {
              if (article.place === '全国') {
                // 全国はOK
              } else if (article.place === keyword) {
                // 指定された地域が一致する場合
              } else {
                // 指定された地域が一致しない場合
                return;
              }
            }
          }

          // 記事全般ならタイトルでフィルタリング
          if (argType === 'search.type_article') {
            if (!article.title.includes(keyword)) {
              return;
            } else {
              found = true;
            }
          }
        }

        // 指定されたタグを含む記事がないか検索
        for (const arg of args) {
          if (article.tags.includes(arg)) {
            found = true;
            break;
          }
        }

        // 見つかったらフィルター済みリストに追加
        if (found) {
          this.filteredArticles.push(article);
        }

      })

      resolve(this.filteredArticles);
    });
  }

  /**
   * 記事リストのpush
   */
  public pushArticle(data: ArticleCard[]) {
    IrisService.stackedArticles = [];
    IrisService.stackedArticles = data;
  }

  /**
   * 記事リストのpop
   */
  public popArticle(): ArticleCard[] {
    return IrisService.stackedArticles;
  }

  /**
   * routeのリセット
   */
  public resetRoot() {
    IrisService.activeRoute = false;
  }

  /**
   * routeのアクティベート
   */
  public activeRoot() {
    IrisService.activeRoute = true;
  }

  /**
   * routeのアクティベート
   */
  public isActiveRoot(): boolean {
    return IrisService.activeRoute;
  }
  
  /**
   * ページインデックスのリセット
   */
  public resetIndex() {
    IrisService.pindex = 0;
  }

  /**
   * ページインデックスの取得
   */
  public getIndex() {
    return IrisService.pindex;
  }

  /**
   * ページインデックスの設定
   */
  public setIndex(index: number) {
    IrisService.pindex = index;
  }

  /**
   * 配列のシャッフル
   */
  public shuffle(array: any[]) {
    for (let i = array.length; 1 < i; i--) {
      let k = Math.floor(Math.random() * i);
      [array[k], array[i-1]] = [array[i-1], array[k]];
    }
  }
}
